export default __webpack_public_path__ + "static/media/network.d0b168ca.svg";